'use strict';

exports.__esModule = true;

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

exports.filterDateType = filterDateType;
exports.prepareDateRules = prepareDateRules;
exports.isPastDate = isPastDate;

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

var _msk = require('msk');

var _msk2 = _interopRequireDefault(_msk);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function filterDateType(fields) {
  return fields.filter(function (rule) {
    return rule.type === 'date';
  });
} // merge the arr2 into arr1 based on a rule name
// considering the arr2 value over the arr1


function mergeArrays(arr1, arr2) {
  var aux = {};
  arr2.forEach(function (rule) {
    return aux[rule.name] = rule;
  });
  return arr1.map(function (rule) {
    return aux[rule.name] ? aux[rule.name] : rule;
  });
}

function prepareDateRules(rules, intl) {
  return _extends({}, rules, {
    personalFields: mergeArrays(rules.personalFields, setDateRuleValidations(filterDateType(rules.personalFields), intl))
  });
}

function setDateRuleValidations(rules, intl) {
  if (rules) {
    return rules.map(function (rule) {
      var ruleCopy = _extends({}, rule);

      ruleCopy.mask = function (value) {
        return _msk2.default.fit(value, '99/99/9999');
      };

      ruleCopy.validate = function (value) {
        var mom = _moment2.default.utc(value, 'L', intl.locale.toLowerCase());

        return mom.isValid() && rule.validate(mom.unix());
      };

      ruleCopy.display = function (value) {
        return _moment2.default.utc(value, [_moment2.default.ISO_8601, 'L'], intl.locale.toLowerCase()).format('L');
      };

      ruleCopy.submit = function (value) {
        if (!value) return null;

        var date = _moment2.default.utc(value, 'L', intl.locale.toLowerCase(), true);

        if (!date.isValid()) return null;
        return date.format();
      };

      return ruleCopy;
    });
  }

  return rules;
}

function isPastDate(unixTimestamp) {
  var nowMS = Date.now() / 1000;
  return unixTimestamp - nowMS < 0;
}